/* IMPORTS START */
import ApiResponseEnum from '@/app-core/api/enums/ApiResponseEnum'
import Http from '@/app-core/lib/data/api/Http'

import CoreApiResources from '@/app-core/api/ApiResources.js'
import CoreApiEndpoints from '@/app-core/api/ApiEndpoints.js'
import ThemeApiResources from '@/app-theme/api/ApiResources.js'
import ThemeApiEndpoints from '@/app-theme/api/ApiEndpoints.js'
import {clone} from '@/core/lib/utils/helper/index.js'
/* IMPORTS END */

export const API = {
  get RESTRequest() {
    return Http.Request
  },
  get RESTRequestAll() {
    return Http.RequestAll
  },
  get RESTClient() {
    return Http
  },

  get Resource() {
    return {
      /* RESOURCES */
      ...CoreApiResources,
      ...ThemeApiResources
    }
  },

  get Endpoint() {
    return clone({
      /* ENDPOINTS */
      ...CoreApiEndpoints,
      ...ThemeApiEndpoints
    })
  },

  responseData     : (response) => response?.data?.data || null,
  responseErrors   : (response) => response?.data?.error || null,
  isResponseSuccess: (response) =>
    response?.status === ApiResponseEnum.SUCCESS &&
    response?.data?.status === ApiResponseEnum.SUCCESS &&
    API.responseData(response) && !API.responseErrors(response)
}

export {default as Http} from '@/app-core/lib/data/api/Http'
export default API
